import { useNavigate } from 'react-router-dom';

export const useGoBack = () => {
    console.log('working');
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1); // This will go back one step in the history
    };
    return handleGoBack;
};